// Dictionary
import { uri } from '../data-util'
import langs from './language.json'

// Builder
import { html, render } from 'lit/html.js'
import 'view-base/unit-link'
import textico from 'url:view-base/type-icon/file-text-o.svg'

// Selector
import { get as val } from 'object-path'

// Scores
import * as qtc from '../view-advice-qtc'
import { provider } from './provider'

export function textTable( xeon ) {

  const lang = uri.lang()
  const dict = langs[ lang ]
  const data = provider( xeon )

  // ------------------------
  // HEAD
  // ------------------------
  const head = []
  const cols = []
  // Score Name
  cols.push( html `<th>${dict["table_score"]}</th>` )
  // Frequency
  cols.push( html `<th>
    <span style="font-size:1.2em;">&sum;</span>
    ${dict["table_points"]}
  </th>` )

  for ( const drug of Object.values( xeon.drugs ) ) {
    cols.push( html `<th>${drug.name[lang].substr(0,3)}</th>` )
  }
  // Finalize
  head.push( html `<tr>${cols}</tr>` )

  // ------------------------
  // BODY
  // ------------------------
  const textIcon = { src: textico, cursor: "pointer", fill: "#6CBCFF", className: "hash" }
  const rows = []
  const refs = []

  // -----------------------
  // QTC
  // -----------------------
  const cols3 = []
  cols3.push( html `<td>
    <span style="color:ghostwhite">RISQ-PATH</span>
    <sup>c</sup>
  </td>` )

  // Points
  const { riskPoints, riskPointsUnknown } = data.computeRisk()
  if ( riskPoints >= 7 ) {
    const style = `background:rgba(247,103,158,${Math.min(riskPoints/13,0.8)});`
    cols3.push( html `<td style=${style}>${riskPoints}</td>` )
  } else {
    cols3.push( html `<td>${riskPoints}</td>` )
  }

  // Drugs
  for ( const drug of Object.values( xeon.drugs ) ) {
    if ( data.drugsWith( 'conditional' ).map( drug => drug.id ).includes( drug.id ) ) {
      const style = `background:rgba(247,103,158,${1/5});`
      cols3.push( html `<td style="${style}"> + </td>` )
    } else if ( data.drugsWith( 'possible' ).map( drug => drug.id ).includes( drug.id ) ) {
      const style = `background:rgba(247,103,158,${3/5});`
      cols3.push( html `<td style="${style}"> ++ </td>` )
    } else if ( data.drugsWith( 'known' ).map( drug => drug.id ).includes( drug.id ) ) {
      const style = `background:rgba(247,103,158,${5/5});`
      cols3.push( html `<td style="${style}"> +++ </td>` )
    } else {
      cols3.push( html `<td> Ø </td>` )
    }
  }
  // Ende qtc row
  rows.push( html `<tr>${cols3}</tr>` )

  // Legende
  refs.push( html `<span>${dict["qtc_prefix"]} </span>` )
  refs.push( html `<span>${dict["qtc_limit"]} </span>` )
  // Case threshold drugs and we ask questions
  if ( qtc.questions( xeon ).length > 0 ) {
    refs.push( html `<span>${dict["qtc_question"]}</span>` )
  }
  if ( riskPoints + riskPointsUnknown >= 10 ) {
    refs.push( html `<span>${dict["qtc_avoid"]}</span>` )
  }

  return html `
    <table class="scores zahl">
      <thead>${ head }</thead>
      <tbody>${ rows }</tbody>
    </table>
    <div class=caption>${ refs }</div>
    `
}